export const USER_SECURITY_DETAILS = 'user-security-details';
